import { lazy } from 'react';

export const CurrentCase = lazy(() => import('./CurrentCase.component'));
